import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const toTop = () => window.scrollTo({ top: 0, behavior: "auto" });

const renderLink = (item) =>
  item.external ? (
    <a href={item.to} target="_blank" rel="noreferrer">
      {item.label}
    </a>
  ) : (
    <Link to={item.to} onClick={toTop}>{item.label}</Link>
  );

function PolicyTemplate({ policy }) {
  const {
    eyebrow = "Policies",
    title,
    intro,
    updated = "October 19, 2026",
    sections,
    related = [],
    className = "",
  } = policy;

  return (
    <main className={`policy-page ${className}`.trim()} id="main-content">
      <header className="policy-hero">
        <p className="policy-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="policy-updated">Last updated {updated}</p>
        <p className="policy-intro">{intro}</p>
      </header>

      <div className="policy-layout">
        <aside className="policy-toc">
          <nav aria-label="On this page">
            <p>On this page</p>
            <ol>
              {sections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.title}</a>
                </li>
              ))}
            </ol>
          </nav>
        </aside>

        <article className="policy-content">
          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <span className="policy-section-number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h2>{section.title}</h2>
              {section.paragraphs?.map((paragraph, paragraphIndex) => (
                <p key={`${section.id}-p-${paragraphIndex}`}>{paragraph}</p>
              ))}
              {section.bullets && (
                <ul>
                  {section.bullets.map((item) => <li key={item}>{item}</li>)}
                </ul>
              )}
              {section.steps && (
                <ol>
                  {section.steps.map((item) => <li key={item}>{item}</li>)}
                </ol>
              )}
              {section.links?.map((item) => (
                <p key={`${section.id}-${item.to}`}>
                  {item.prefix}{renderLink(item)}{item.suffix}
                </p>
              ))}
              {section.email && (
                <p>
                  Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
                  {section.emailSuffix || "."}
                </p>
              )}
            </section>
          ))}

          {related.length > 0 && (
            <nav className="policy-related" aria-label="Related policies">
              <p>Related policies</p>
              <div>
                {related.map((item) => (
                  <Link to={item.to} key={item.to} onClick={toTop}>
                    {item.label} <span aria-hidden="true">&rarr;</span>
                  </Link>
                ))}
              </div>
            </nav>
          )}
        </article>
      </div>
    </main>
  );
}

export default PolicyTemplate;
